import { toCsvText } from "../../utils/csv";
import type { TrustedContact } from "../../types/trusted-contacts";
import { contactTypeLabel } from "./contactTypes";

/**
 * The CSV text for a directory export: one row per contact, in the order given.
 *
 * Takes the contacts the caller has already resolved — which is the whole filtered directory, not
 * the page on screen. A file that disagreed with the count the coach was shown would be worse than
 * no export.
 *
 * Notes are exported as a sixth column beyond the five the spec names. A contact's note is the
 * only field that says what they are *for* ("Great contact for RHPs"), and a spreadsheet the staff
 * shares without it loses the judgement that made the directory worth keeping.
 */
export const buildTrustedContactsCsv = (contacts: TrustedContact[]): string =>
  toCsvText([
    ["Name", "Organization", "Type", "Phone", "Email", "Notes"],
    ...contacts.map((c) => [
      c.name,
      c.organizationName ?? "",
      contactTypeLabel(c.contactType),
      // The number as the coach entered it, not its E.164 form — this file is for reading, and a
      // spreadsheet is where a coach copies a number from to dial it.
      c.phone ?? "",
      c.email ?? "",
      c.notes ?? "",
    ]),
  ]);

/** A filesystem-safe filename for the export. */
export const trustedContactsCsvFileName = (): string => {
  const today = new Date().toISOString().slice(0, 10);
  return `trusted-contacts-${today}.csv`;
};
